<template>
  <div class="footer-follow-us-section__wrapper">
    <p class="footer-follow-us-section__title subtitle-3">Follow Us</p>
    <footer-socials :items="footerSocials" />
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import FooterSocials from './FooterSocials'

export default {
  name: 'FooterFollowUsSection',
  components: { FooterSocials },
  props: {
    footerSocials: propValidator([PROP_TYPES.ARRAY])
  }
}
</script>

<style lang="scss" scoped>
.footer-follow-us-section__wrapper {
  .footer-follow-us-section__manage-cookies {
    position: absolute;
    left: 0;
    margin-top: 14px;

    @include mobile {
      position: static;
    }
  }

  a {
    color: $c--white;

    &:hover {
      color: $c--main;
    }
  }
}
</style>
